export default {
    ATIVO: 1,
    LATENTE: 2,
    RESOLVIDO: 3,
}